import { Injectable, signal } from '@angular/core';

@Injectable({ providedIn: 'root' })
export class ThemeService {
  private readonly STORAGE_KEY = 'theme';
  private readonly DARK_CLASS = 'dark-mode';

  darkMode = signal<boolean>(false);

  init(): void {
    const stored = localStorage.getItem(this.STORAGE_KEY);
    const isDark = stored !== null ? stored === 'dark' : window.matchMedia('(prefers-color-scheme: dark)').matches;

    this.darkMode.set(isDark);
    this.applyClass(isDark);
  }

  toggle(): void {
    const next = !this.darkMode();
    this.darkMode.set(next);
    this.applyClass(next);
    localStorage.setItem(this.STORAGE_KEY, next ? 'dark' : 'light');
  }

  applyFamilyBranding(color: string): void {
    document.documentElement.style.setProperty('--p-primary-color', color);
    document.documentElement.style.setProperty('--p-primary-hover-color', this.adjustBrightness(color, -15));
    document.documentElement.style.setProperty('--p-primary-active-color', this.adjustBrightness(color, -25));
  }

  private adjustBrightness(hex: string, percent: number): string {
    const num = parseInt(hex.replace('#', ''), 16);
    const r = Math.min(255, Math.max(0, ((num >> 16) & 0xff) + Math.round(2.55 * percent)));
    const g = Math.min(255, Math.max(0, ((num >> 8) & 0xff) + Math.round(2.55 * percent)));
    const b = Math.min(255, Math.max(0, (num & 0xff) + Math.round(2.55 * percent)));
    return '#' + ((1 << 24) | (r << 16) | (g << 8) | b).toString(16).slice(1);
  }

  private applyClass(isDark: boolean): void {
    document.documentElement.classList.toggle(this.DARK_CLASS, isDark);
  }
}
